import { PageHeader } from '@/components/Card'
import { EmailCard } from '@/components/account/EmailCard'
import { NotificationsCard } from '@/components/account/NotificationsCard'
import { PasswordCard } from '@/components/account/PasswordCard'
import { PushCard } from '@/components/account/PushCard'
import { ReferralCard } from '@/components/account/ReferralCard'
import { SessionsCard } from '@/components/account/SessionsCard'

/*
 * One job per card, in the order people actually need them: who you are, how
 * you get told things, what you can hand out, what is signed in. A single
 * column throughout — these are settings, not a dashboard, and two columns on a
 * wide screen only makes the eye hunt for the next one.
 *
 * Under `sm` the cards run edge to edge so each reads as a board row rather
 * than a floating panel.
 */
export function AccountPage() {
  return (
    <div className="space-y-5">
      <PageHeader title="Account" description="Your details, notifications and devices." />

      <div className="-mx-4 space-y-3 sm:mx-0 sm:space-y-5">
        <EmailCard />
        <PasswordCard />
        <PushCard />
        <NotificationsCard />
        <ReferralCard />
        <SessionsCard />
      </div>
    </div>
  )
}
